// The clinic works in Argentina time. Browsers elsewhere must still see the clinic's wall-clock times and days,
// so every appointment time is formatted explicitly in this zone instead of the viewer's local zone.
export const CLINIC_TZ = 'America/Argentina/Buenos_Aires';

const timeFmt = new Intl.DateTimeFormat('es-AR', { timeZone: CLINIC_TZ, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
const dayFmt = new Intl.DateTimeFormat('en-CA', { timeZone: CLINIC_TZ, year: 'numeric', month: '2-digit', day: '2-digit' }); // en-CA => YYYY-MM-DD

/** "09:30" in clinic time. Returns '' for invalid input. */
export const clinicTime = (iso: string | Date | undefined | null): string => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '' : timeFmt.format(d);
};

/** "2026-10-07" in clinic time (the clinic's calendar day for that instant). */
export const clinicDateKey = (iso: string | Date | undefined | null): string => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '' : dayFmt.format(d);
};

/** A Date at local noon for a YYYY-MM-DD key (safe to hand to date-fns/DayPicker formatting). */
export const dateFromKey = (key: string): Date => {
  const [y, m, d] = key.split('-').map(Number);
  return new Date(y, m - 1, d, 12, 0, 0);
};

/** Drop a professional title so greetings read "Hola, Laura" and not "Hola, Dra.". */
export const firstName = (full?: string | null): string => {
  const words = (full || '').trim().split(/\s+/).filter(w => !/^(dr|dra|lic|prof|mg|esp)\.?$/i.test(w));
  return words[0] || (full || '').trim().split(/\s+/)[0] || '';
};
